import { StripePlan } from '@tryhackme/interfaces';
import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useFeatureIsOn } from 'src/common/growthbook';
import { useChargebeeCheckout } from 'src/common/hooks/use-chargebee-checkout';
import type { GenerateCheckoutPayload } from 'src/common/hooks/use-chargebee-checkout/use-chargebee-checkout.types';
import { CheckoutType } from 'src/common/hooks/use-chargebee-checkout/use-chargebee-checkout.types';
import { useStripeSubscriptionCheckout } from 'src/common/hooks/use-stripe-subscription-checkout';

export const useSubscriptionCheckout = (): {
  isLoading: boolean;
  openCheckout: (payload?: GenerateCheckoutPayload) => Promise<void>;
} => {
  const isStripeEnabled = useFeatureIsOn('use-stripe-for-new-subscriptions');

  const chargebeeCheckout = useChargebeeCheckout(CheckoutType.SUBSCRIPTION);
  const stripeCheckout = useStripeSubscriptionCheckout();

  if (isStripeEnabled) {
    return {
      isLoading: stripeCheckout.isLoading,
      openCheckout: async (payload?: GenerateCheckoutPayload) => {
        if (!payload || !('interval' in payload) || !payload.interval) {
          NotificationDispatch('error', 'Please select a billing interval');
          return;
        }

        await stripeCheckout.openCheckout({
          planType: StripePlan.REGULAR,
          interval: payload.interval,
          ...('campaign' in payload && payload.campaign ? { campaign: payload.campaign } : {}),
        });
      },
    };
  }

  return {
    isLoading: chargebeeCheckout.isLoading,
    openCheckout: async (payload?: GenerateCheckoutPayload) => {
      chargebeeCheckout.openCheckout?.(payload);
      await Promise.resolve();
    },
  };
};
